import { PageController } from '@client/components/_core/layout/PageController';
import { LandingPageSections } from '@client/components/_ui/display/landing-page-sections';
import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute } from '@tanstack/react-router';
import { Settings } from 'lucide-react';
import { useConfigurationLandingItems } from './useConfigurationLandingItems';

export const Route = createFileRoute('/console/$orgId/configuration/')({
    staticData: {
        ui: {
            title: 'Control centre',
            subtitle: 'Manage your organisation settings, integrations and preferences.',
            icon: Settings,
            widthVariant: 'default',
        },
        permissions: ORG_CONFIG_PERMISSIONS,
    },
    component: ConfigurationHome,
});

// ============================================================================
// Main Component
// ============================================================================

function ConfigurationHome() {
    const sections = useConfigurationLandingItems();

    return (
        <PageController route={Route}>
            <LandingPageSections sections={sections} columns={4} />
        </PageController>
    );
}
